import * as Herz from '@rushplay/herz'

// TODO: move to Herz
export function mapToKebabCase(arr) {
  return arr && arr.map(item => Herz.Utils.Strings.toKebabCase(item))
}
